// The regular expression to match YouTube URLs with /watch?v= or youtu.be/ formats
export default () => {
  const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&?]+)/;

  return regex;
};
